// The VOIA web app: the desktop planner (trips and country visits) built from the
// mobile repo and hosted on its own subdomain. The site only links to it; clicks
// are tagged and counted by src/utils/trackStoreClicks.js.
export const WEB_APP_URL = 'https://app.voiatravel.com';
export const WEB_APP_HOST = new URL(WEB_APP_URL).hostname;

// What the "Get the app" QR code opens: src/pages/GetAppPage sends phones to
// their store. Changing it means regenerating public/assets/get-app-qr.svg.
export const GET_APP_URL = 'https://voiatravel.com/get';
